import { message, Modal, ModalFuncProps, notification } from 'ant-design-vue';
import { omit, SYS_PREFIX } from '.';

// const messageApi = {};
// ['info', 'success', 'error', 'warning', 'warn'].forEach((type) => {
//   messageApi[type] = (...args: any[]) => {
//     message.config({ getContainer });
//     message[type].apply(this, args);
//   };
// });
// Object.assign(message, messageApi);

export { message, notification };

let t = (key: string) => key;
export const registeT = (tFn: (key: string) => string) => (t = tFn);

export const useAlert = (props: ModalFuncProps) => {
  const { type = 'warning' } = props;
  return Modal[type](
    getConfirmModalProps({
      class: `${SYS_PREFIX}-confirm ${props.class || ''}`,
      title: 'common.reminder',
      ...omit(props, ['type', 'class']),
    }),
  );
};

export const useConfirm = (props: ModalFuncProps) => useAlert({ ...props, type: 'confirm' });

const getConfirmModalProps = (props?: ModalFuncProps) => {
  if (!props) return {};
  if (props.title && typeof props.title === 'string') {
    props.title = t(props.title);
  }
  if (props.content && typeof props.content === 'string') {
    props.content = t(props.content);
  }
  return props;
};

const createModal = (props: ModalFuncProps) => {
  const { type = 'warning' } = props;
  return Modal[type]({
    centered: true,
    ...props,
  });
};
export const createSuccessModal = (options: ModalFuncProps) =>
  createModal({ ...options, type: 'success' });

export const createErrorModal = (options: ModalFuncProps) =>
  createModal({ ...options, type: 'error' });

export const createInfoModal = (options: ModalFuncProps) =>
  createModal({ ...options, type: 'info' });

export const createWarningModal = (options: ModalFuncProps) =>
  createModal({ ...options, type: 'warning' });
